import React from 'react';
import { ReactComponent as ExitCofirmIcon } from '../../assets/icons/exit-confirm-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/x-icon.svg';

const ExitModal = ({ closeModal, logout}) => {
    return (
        <div className="modal-overlay" onClick={() => closeModal()}>
            <div className="modal-container" style={{ minWidth: "320px", maxWidth: "520px" }} onClick={(e) => e.stopPropagation()}>
                <div className="modal-header" style={{ justifyContent: "flex-end" }}>
                    <button
                        onClick={closeModal}
                        className='modal-header-close-button'
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#4b5563")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "#9ca3af")}
                    >
                        <CloseIcon size={24} />
                    </button>
                </div>

                <div className='modal-body' style={{justifyContent: "center", gap: "40px", alignItems: "center"}}>
                    <ExitCofirmIcon />

                    <div style={{justifyContent: "center", gap: "12px", alignItems: "center"}}>
                        <div style={{fontWeight: 500, fontSize: "24px", textAlign: "center", color: "#010101"}}>
                            Вы уверены, что хотите выйти?
                        </div>

                        <div style={{fontWeight: 400, fontSize: "18px", textAlign: "center", color: "#4A4A4A"}}>
                            После выхода вам нужно будет снова войти в систему.
                        </div>
                    </div>

                    <div style={{display: 'flex', width: "100%", justifyContent: "space-between", gap: "16px", flexDirection: "row"}}>
                        <button
                            onClick={() => closeModal()}
                            style={{flex: 1}}
                            type="button" className="cancel-button"
                        >
                            Отмена
                        </button>
                        <button
                            onClick={() => logout()}
                            style={{flex: 1}}
                            type="button" className="primary-button"
                        >
                            Выйти
                        </button>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default ExitModal;
